const affirmConstants = {
  affirmScript:
    process.env.BOOTSTRAP_DC === 'nw'
      ? 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js'
      : 'https://cdn1.affirm.com/js/v2/affirm.js',
  affirmKey:
    process.env.BOOTSTRAP_DC === 'nw' ? 'O9NLTT10GHUMZ2RY' : 'B113KZYN4XRG09VK',
  affirmBaseFare: 199
}

export { affirmConstants }
